import { OrganizationsService } from 'app/API';
import { cancelOnSignal } from 'app/API/core/CancelablePromise';
import type { QueryFunctionContext } from '@tanstack/react-query';
import type { TCall } from '../types/TCall';
import type { organizationsKeys } from './organizationsKeys';

type TParams = QueryFunctionContext<ReturnType<typeof organizationsKeys.workspacesByOrg>>;

export const createFetchOrgWorkspacesQueryFn =
  (call: TCall) =>
  ({ queryKey: [{ organizationId }], signal }: TParams) =>
    call(() => cancelOnSignal(OrganizationsService.getOrgWorkspaces({ oid: organizationId }), signal));
